import React from "react";

const BottomCards = ({ activePage, onFaq, onRegister, onEnquiry }) => {
  return (
    <div className="row g-3 mt-4">
      {/* FAQ */}
      {activePage !== "faq" && (
        <div className="col-6 col-md-6">
          <div className="bottom-card" onClick={onFaq}>
            <div className="bottom-icon blue">
              <i className="fa fa-question"></i>
            </div>

            <div className="bottom-content">
              <h6>FAQ</h6>
              <p>View frequently asked questions</p>
            </div>
          </div>
        </div>
      )}

      {/* Register */}
      {activePage !== "register" && (
        <div className="col-6 col-md-6">
          <div className="bottom-card" onClick={onRegister}>
            <div className="bottom-icon green">
              <i className="fa fa-user-plus"></i>
            </div>

            <div className="bottom-content">
              <h6>Register</h6>
              <p>Player Registration</p>
            </div>
          </div>
        </div>
      )}

      {/* Enquiry */}
      {activePage !== "enquiry" && (
        <div className="col-6 col-md-6">
          <div className="bottom-card" onClick={onEnquiry}>
            <div className="bottom-icon orange">
              <i className="fa fa-comments"></i>
            </div>

            <div className="bottom-content ">
              <h6>Inquiry</h6>
              <p>Have questions? Contact us</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomCards;
